import React, { useEffect } from "react";

const DeliveryAndReturns = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Teslimat ve İade Şartları</h1>
      <p className="text-gray-600 mb-4">
        HalisahaBul üzerinden yapılan rezervasyonlar, aşağıda belirtilen
        teslimat ve iade şartlarına tabidir.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Teslimat Şartları</h2>
      <p className="text-gray-600 mb-4">
        - Rezervasyonlar, seçilen tarih ve saat için geçerlidir. <br />
        - Kullanıcılar, rezervasyon detaylarını e-posta veya SMS yoluyla
        alacaktır. <br />- Rezervasyon yapılan sahaya zamanında gidilmesi
        gerekmektedir.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. İptal ve İade Politikası
      </h2>
      <p className="text-gray-600 mb-4">
        - Rezervasyon iptali, müsaitlik durumuna bağlı olarak belirli bir süre
        öncesine kadar yapılabilir. <br />
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Ödeme İadesi</h2>
      <p className="text-gray-600 mb-4">
        - İptal edilen rezervasyonlar için iade süreci, ödeme yöntemine bağlı
        olarak 3-7 iş günü sürebilir. <br />- Kullanıcıların, iade taleplerini
        destek ekibimize iletmeleri gerekmektedir.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Destek ve İletişim</h2>
      <p className="text-gray-600 mb-4">
        - İptal ve iade süreçleri hakkında bilgi almak için bizimle iletişime
        geçebilirsiniz. <br />
        - 📧 Email: destek@halisahabul.com <br />- 📞 GSM: +90 (538) 237 1255
      </p>
    </div>
  );
};

export default DeliveryAndReturns;
